// transfers
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import WebbSpinText from "../webb/webb-spintext";
import ListNoData from "../webb/list-nodata";

import { UserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { GetUserAccountsList } from "../../services/srvc-accounts-realm";



export default function AccountsListModule() {

  const asset = UserForm() === 'in' ? GetLocalUser() : GetLocalBusiness();
  // console.log (asset)
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        const acnx = await (GetUserAccountsList({
          data: {usid: asset.usid},
          user: asset.usid
        }))
        setData(acnx.data)
      }
      fetchData()
    } else {}
  },[asset.usid]);


  if (loading){ return ( <> <WebbSpinText /> </> ) }
  if (!data || data.length === 0) { 
  return ( 
  <> 
    <div className="p-3 bg-white rounded-wd text-center text-color-tone">
      No Linked Accounts
    </div>
  </> 
  ) }

  return (
  <>
    {/* {console.log(data)} */}
    <div className="">

      {data && data.map((item, i) => (
        <div className="d-flex bg-wite p-3 rounded-wd mb-3 hilite" key={i}>
          
          <div className="">
            <p className="fw-bold m-0">{item.acbl}</p>
            <p className="small m-0 text-truncate" style={{fontFamily:'monospace'}}>{item.acnt}</p>
          </div>

          <div className="ms-auto">
            <div className="bg-lite rounded-circle text-center py-1" 
              style={{width:'2.4rem', height:'2.4rem'}}>
              <i className="bi-arrow-clockwise lead text-color-tone"></i>
            </div>
          </div>

        </div>
      ))}

    </div>

  </>
  )
}